import React from 'react';
import { Avatar } from '@mui/material';
import User from '../../types/User';
import Workspace from '../../types/Workspace';

type AvatarProps = {
  user?: User;
  workspace?: Workspace;
  size: number;
  color?: "primary" | "secondary";
}

const AvatarWrapper = (props: AvatarProps) => {
  const initials = () => {
    let initials = props.user?.display_name ?? props.workspace?.name;
    if (!initials) { return "" }
    return initials.split(" ").slice(0,2).map((name) => name.charAt(0)).join("");
  }
  return(
    <Avatar variant="rounded" sx={{width: props.size, height: props.size, fontSize: `${props.size * 0.4}px !important`, backgroundColor: props.color == "primary" ? "var(--color-purple)" : "var(--color-purpleLight)"}}>
      <span className={props.color == "primary" ? "text-white" : "text-info"}>{initials()}</span>
    </Avatar>
  );
}

export default AvatarWrapper;